import { call, put, takeLatest } from 'redux-saga/effects'

import {
  searchAzureUsersFailed,
  searchAzureUsersSuccess,
  SEARCH_AZURE_USERS_START,
} from '~/modules/configuration/redux/actions/azure-user'
import { api } from '~/services/api'
import { validateStatus } from '~/utils/api'

/**
 * Search user API
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
export const searchAzureUsersApi = (params) => {
  const uri = `/azure-resource`
  return api.get(uri, params)
}

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doSearchAzureUsers(action) {
  try {
    const response = yield call(searchAzureUsersApi, action?.payload)

    if (validateStatus(response.statusCode)) {
      const payload = {
        list: response.data.items,
        ...response?.data?.meta,
      }
      yield put(searchAzureUsersSuccess(payload))

      // Call callback action if provided
      if (action.onSuccess) {
        action.onSuccess()
      }
    } else {
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(searchAzureUsersFailed())
    // Call callback action if provided
    if (action.onError) {
      action.onError()
    }
  }
}

/**
 * Watch search users
 */
export default function* watchSearchAzureUsers() {
  yield takeLatest(SEARCH_AZURE_USERS_START, doSearchAzureUsers)
}
